import type { TEventMessages } from "../../../services/api/instances/researchApi/types";

export const mergeEventMessages = (
  existingMessages: TEventMessages[] | undefined,
  newMessages: TEventMessages[]
): TEventMessages[] => {
  const existing =
    existingMessages && existingMessages.length !== 0 ? existingMessages : [];

  const messageMap = new Map<string, TEventMessages>();

  for (const msg of existing) {
    messageMap.set(msg.timestamp, msg);
  }

  for (const msg of newMessages) {
    messageMap.set(msg.timestamp, msg);
  }

  return Array.from(messageMap.values()).sort((a, b) =>
    b.timestamp.localeCompare(a.timestamp)
  );
};
